import React, { FC } from "react";
import { Tag } from "antd";
import { TitleStatusBankProps } from "../../components/Chat/Types/Type";
const style: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  paddingLeft: 20,
  paddingRight: 20,
};
const styleTag: React.CSSProperties = {
  height: "fit-content",
};

// тэг
export const TitleStatusBank: FC<TitleStatusBankProps> = ({
  title,
  status,
  color,
}) => {
  return (
    <div style={style}>
      <h1>{title}</h1>
      <Tag style={styleTag} color={color}>
        {status}
      </Tag>
    </div>
  );
};
